import React, { useState } from 'react'
import { Button } from 'components/Form'
import { I18n } from 'react-redux-i18n'
import ModalWrapper from 'components/ModalWrapper'
import { useSelector } from 'react-redux'
import { TextEditorHTML } from 'components/TextEditorHTML'
import { SignaturePreviewModal } from '../ChatMail/SignaturePreviewModal'

const Signature = (props) => {
  const { id, label, options, onChange, value, placeholder } = props
  const [ isOpenModalSignature, setIsOpenModalSignature ] = useState(false)
  const company = useSelector((store) => store.companies)
  const [ isOpenModalPreview, setIsOpenModalPreview ] = useState(false)
  const [ preview, setPreview ] = useState(value)

  return (
    <div className='channel-field'>
      <Button primary value={I18n.t(label)} onClick={()=>setIsOpenModalSignature(true)} className='button-large' />
      <ModalWrapper
        id={'modalSignature'}
        header={I18n.t('channels_chatmail_create_signature')}
        legend={I18n.t('channels_chatmail_legend_signature')}
        body={
          <div>
            <TextEditorHTML
              id={id}
              company={company}
              channel={'chatmail'}
              value={value || ''}
              options={options}
              placeholder={placeholder}
              onPreviewMsg={()=>setIsOpenModalPreview(true)}
              onChange={(e) => {
                setPreview(e.valueHtml)
                onChange(e.valueHtml)
              }}
              className={'signature'}
            />
          </div>
        }
        isOpen={isOpenModalSignature}
        toggle={()=>setIsOpenModalSignature(!isOpenModalSignature)}
        showClose={true}
        eventBtn={()=>setIsOpenModalSignature(false)}
        eventBtnTxt={I18n.t('dashboard_accept')}
      />
      <SignaturePreviewModal
        isOpen={isOpenModalPreview}
        toggle={()=>setIsOpenModalPreview(!isOpenModalPreview)}
        signature={preview}
      />
    </div>
  )
}

export default Signature